module.exports = __webpack_public_path__ + "img/nswliberal.2e4c3fb.jpg";